import { Component, Input, OnInit } from "@angular/core";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import { ColorsService } from "@arch/domain/application/services/colors.service";
import {
    CompanyEntity,
    PointEntity,
    SerieEntity,
    VisualizationEntity
} from "@arch/domain/entity";
import { HighchartsRenderComponent } from "../../highcharts-render/highcharts-render.component";
import { FormatNumbers } from "@arch/_shared/utils/format-number.utils";
import { FlexLayoutModule } from "@angular/flex-layout";
import { SharedDsnModule } from "../../../modules/shared-dsn.module";
import { InputComponent } from "../../dsn/input/input.component";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
    imports: [
        HighchartsRenderComponent,
        FlexLayoutModule,
        SharedDsnModule,
        InputComponent
    ],
    templateUrl: "./chart-with-input.component.html",
    styleUrl: "./chart-with-input.component.scss"
})
export class ChartWithInputComponent implements OnInit {
    @Input() visualization!: VisualizationEntity;
    @Input() options!: VisualizationOptionsType;
    @Input() series!: SerieEntity[];
    @Input() company!: CompanyEntity;
    @Input() points!: PointEntity[];

    public currency: string = "";

    public chartStructure: any = {};
    ngOnInit(): void {
        this.setStructureChart();
    }

    private setStructureChart() {
        const color = "black.petroleum";

        const series = this.visualization.props.series.map((serieId) => ({
            _id: serieId,
            color,
            type: "column"
        }));

        const configs: any = {
            goals: [],
            credits: {
                enabled: false
            },
            category: "column",
            plotOptions: {
                borderWidth: 0,
                series: {
                    marker: {
                        enabled: true,
                        radius: 2
                    },
                    animation: {
                        duration: 1000
                    },

                    states: {
                        hover: {
                            enabled: true,
                            fillOpacity: 1
                        }
                    },
                    color: color
                }
            },
            series,
            chart: {
                reflow: true,
                type: "column"
            },
            legend: {
                enabled: false
            },
            yAxis: {
                title: {
                    enabled: false
                },
                plotLines: [
                    {
                        zIndex: 6
                    }
                ],
                labels: {
                    enabled: true
                }
            }
        };

        if (this.options.goals && this.visualization.props?.goals?.length) {
            configs.goals = this.visualization.props?.goals.map((goal) => {
                return {
                    _id: goal.r,
                    color: "petroleum.light",
                    dashStyle: "ShortDash",
                    lineWidth: 3
                };
            });
        }

        this.visualization.setChartConfiguration(configs);
    }

    public onUpdateCashBalance() {}
}

export interface IChartWithInputComponent {
    series: SerieEntity[];
    points: PointEntity[];
    visualization: VisualizationEntity;
    options: VisualizationOptionsType;
    company?: CompanyEntity;
}
